import React from 'react';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { AwardForm } from '../../components/admin/awards/AwardForm';
import { useParams } from 'react-router-dom';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const AwardFormPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  return (
    <AdminLayout>
      <div className="py-8 space-y-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col gap-6">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-4">
                <Button variant="ghost" size="sm" onClick={() => navigate(-1)}>
                  <ArrowLeft className="h-4 w-4" />
                </Button>
                <h1 className="text-2xl font-bold">
                  <span className="bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 text-transparent bg-clip-text">
                    {slug ? 'Modifier un Award' : 'Créer un Award'}
                  </span>
                </h1>
              </div>
            </div>

            <Card>
              <CardContent className="p-6">
                <AwardForm slug={slug} />
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AwardFormPage;
